define.alias("shared/components/shared/ui/report/settings-wrapper", "media/components/shared/ui/report/settings-wrapper");